module.exports = __webpack_public_path__ + "img/fau2022_blue.decd05d6.svg";